import React from 'react';
import BWAccordion from 'components/shared/BWAccordion';
import FormItem from 'components/shared/BWFormControl/FormItem';
import FormSelect from 'components/shared/BWFormControl/FormSelect';
import FormTextArea from 'components/shared/BWFormControl/FormTextArea';

const STATUS_OPTIONS = [
    { value: 1, label: 'Mới ứng tuyển' },
    { value: 2, label: 'Đạt yêu cầu' },
    { value: 3, label: 'Không đạt' },
];

const CandidateEvaluation = ({ disabled, title }) => {
    return (
        <BWAccordion title={title}>
            <div className='bw_row'>
                <div className='bw_col_12'>
                    <FormItem label='Trạng thái' isRequired={true} disabled={disabled}>
                        <FormSelect
                            field='status'
                            list={STATUS_OPTIONS}
                            placeholder='Chọn trạng thái duyệt'
                            validation={{
                                required: 'Trạng thái là bắt buộc',
                            }}
                        />
                    </FormItem>
                </div>

                <div className='bw_col_12'>
                    <FormItem label='Ghi chú về ứng viên' disabled={disabled}>
                        <FormTextArea
                            field='note'
                            placeholder='Nhập ghi chú đánh giá về ứng viên'
                            rows={5}
                        />
                    </FormItem>
                </div>
            </div>
        </BWAccordion>
    );
};

export default CandidateEvaluation;

